import { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { exchangeGoogleSession } from "@/lib/userAuth";
import { Loader2, AlertCircle } from "lucide-react";

export default function AuthCallback() {
  const nav = useNavigate();
  const location = useLocation();
  const [error, setError] = useState(null);
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { setError("session_id mancante"); return; }
    const sessionId = decodeURIComponent(match[1]);
    exchangeGoogleSession(sessionId)
      .then(() => nav("/profilo", { replace: true }))
      .catch((e) => setError(e.response?.data?.detail || "Impossibile completare il login Google."));
  }, []);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center px-6">
      {error ? (
        <div className="paper-card p-8 max-w-md text-center" data-testid="auth-callback-error">
          <AlertCircle className="w-12 h-12 text-labor-terracotta mx-auto mb-4" />
          <h1 className="font-display text-2xl mb-2">Login non riuscito</h1>
          <p className="text-labor-muted text-sm mb-4">{error}</p>
          <button onClick={() => nav("/accedi")} className="olive-btn px-5 py-2 font-semibold">Torna al login</button>
        </div>
      ) : (
        <div className="text-center" data-testid="auth-callback-loading">
          <Loader2 className="w-10 h-10 animate-spin text-labor-olive mx-auto mb-4" />
          <div className="font-display text-lg">Accesso in corso…</div>
          <div className="text-labor-muted text-sm mt-1">Sto verificando il tuo account Google.</div>
        </div>
      )}
    </div>
  );
}
